import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
// import MainLayout from '../../layouts/MainLayout';
import UserProfileUploadImage from '../../components/UserProfileUploadImage';
import "../../styles/MyProfile.css";

const MyProfile = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData] = useFetch();
  const userId = authState.user._id;

  const [profileData, setProfileData] = useState({
    userId: userId,
    name: authState.user.name,
    gender: 0,
    dob: '',
    email: authState.user.email,
    mobile: '',
    addOnEmail: '',
    addOnContact: '',
    address: '',
    city: '',
    state: '',
    country: '',
    pincode: '',
    upiID: '',
    institution: '',
    socialLinks: '',
    personalPageLink: '',
    bio: '',
    showPrayerOnLogin: false,
    prayer: '',
    remarks: '',
    isActive: 1,
    isDeleted: 0,
    isProfilePic: false,
    think5whysCode: authState.user.think5whyscode,
    createdBy: userId,
    dateCreated: new Date(),
    dateUpdated: new Date(),
  });

  const [pictureData, setPictureData] = useState({
    think5whysCode: authState.user.think5whyscode,
    isProfilePic: false,
  });

  const [originalProfileData, setOriginalProfileData] = useState({});
  const [profileExists, setProfileExists] = useState(false);
  const [profileId, setProfileId] = useState('');
  const [loading, setLoading] = useState(true);
  const [createSuccess, setCreateSuccess] = useState(false);
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [createSuccessMsg, setCreateSuccessMsg] = useState('');
  const [updateSuccessMsg, setUpdateSuccessMsg] = useState('');
  const [creatingProfile, setCreatingProfile] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchUserProfile(userId);
  }, [userId]);

  const fetchUserProfile = useCallback(() => {
    try {
      const config = {
        url: "/myprofile/byid",
        method: 'post',
        data: { userId: userId },
        headers: { Authorization: authState.token },
      };
      fetchData(config)
        .then(response => {
          if (response && response.status) {
            // console.log("profile exists ",response);
            setProfileExists(true);
            const { profile } = response;
            setProfileId(profile._id);
            setProfileData({
              ...profileData,
              ...profile,
            });
            setPictureData({
              think5whysCode: profile.think5whyscode,
              isProfilePic: profile.isProfilePic,
            });
          } else {
            setCreateSuccessMsg("Sorry! Profile Not Found. Please retry.");
          }
        })
        .catch(() => {
          setCreateSuccessMsg("Sorry! Profile Not Found. Please retry.");
        });
    } catch {
      setCreateSuccessMsg("Sorry! Profile not found. Please retry.");
    }
  }, [userId, fetchData, setProfileExists]);

  const handleProfileUpdate = useCallback(() => {
    validateInputs();
    const config = {
      url: `/myprofile/updateprofile`,
      method: 'post',
      data: { profileData: profileData, userId: userId},
      headers: { Authorization: authState.token },
    };
    fetchData(config)
      .then(response => {
        if (response && response.status) {
          setOriginalProfileData(profileData);
          setUpdateSuccess(true);
          setUpdateSuccessMsg("Profile updated successfully!");
        } else {
          setUpdateSuccessMsg("Error updating profile! Please retry.");
        }
      })
      .catch(() => {
        setUpdateSuccessMsg("Error updating profile! Please retry.");
      });
  }, [profileData, profileId, fetchData]);

  const handleCancel = () => {
    setProfileData(originalProfileData);
  };

  const handleCreateProfile = () => {
    setCreatingProfile(true);
    fetchProfileCreate();
  };

  const fetchProfileCreate = useCallback(() => {
    const config = {
      url: "/myprofile",
      method: 'post',
      data: profileData,
      headers: { Authorization: authState.token },
    };
    fetchData(config)
      .then(response => {
        if (response && response.status) {
          setCreateSuccess(true);
          setCreateSuccessMsg("Profile Created Successfully");
        } else {
          setCreateSuccessMsg("Sorry! Profile Not Created. Please retry.");
        }
      })
      .catch(() => {
        setCreateSuccessMsg("Sorry! Profile Not Created. Please retry.");
      });
  }, [profileData, fetchData]);

  const validateInputs = () => {
    let isValid = true;
    const errors = {};
    const mobileRegex = /^\d{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // if (!profileData.gender) {
    //   errors.gender = 'Gender is required.';
    //   isValid = false;
    // }

    if (profileData.gender === undefined || profileData.gender === null) {
      errors.gender = 'Gender is required.';
      isValid = false;
    }

    if (!profileData.dob) {
      errors.dob = 'Date of Birth is required.';
      isValid = false;
    }

    if (!emailRegex.test(profileData.email)) {
      setMessage("Please enter a valid email address.");
      isValid = false;
    }

    // if (!profileData.mobile) {
    //   errors.mobile = 'Mobile Number is required.';
    //   isValid = false;
    // } else if (!mobileRegex.test(profileData.mobile)) {
    //   errors.mobile = 'Mobile Number must be exactly 10 digits.';
    //   isValid = false;
    // }

    if (profileData.mobile && profileData.mobile.trim() !== '') {
      if (!mobileRegex.test(profileData.mobile)) {
        errors.mobile = 'Mobile Number must be exactly 10 digits and start with a digit other than 0.';
        isValid = false;
      }
    }

    if (!profileData.state) {
      errors.state = 'State is required.';
      isValid = false;
    }
    if (!profileData.city) {
      errors.city = 'City is required.';
      isValid = false;
    }
    if (!profileData.country) {
      errors.country = 'Country is required.';
      isValid = false;
    }
    if (!profileData.address) {
      errors.address = 'Address is required.';
      isValid = false;
    }
    if (!profileData.pincode) {
      errors.pincode = 'Pincode is required.';
      isValid = false;
    }

    setErrors(errors);
    return isValid;
  };

  return (
    <div className='bg-black'>
      <div className='text-lg mb-4 py-4 border-b border-blue-400 text-white'>
        <h2 className='text-xl lg:text-2xl text-yellow-200'>👤 Think5Whys Profile</h2>
      </div>
      <div className='main-content mt-4 mb-4 border border-b-gray-300 p-6 rounded-lg bg-black text-white'>
        {!profileExists && (
          <div className='flex justify-center mt-4'>
            <button
              className='create-profile-button px-4 py-2 bg-blue-600 rounded-full text-white hover:bg-blue-700'
              onClick={handleCreateProfile}
              disabled={creatingProfile}
            >
              Initiate Your Profile Creation
            </button>
          </div>
        )}
        {profileExists && (
          <>
            <div className='flex flex-col gap-4'>
              <div className='flex flex-col'>
                <label className='text-yellow-200'>Name:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.name}
                  disabled
                />
              </div>

              <div className='flex flex-col'>
                <label className='text-yellow-200'>User Code:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="text"
                  value={profileData.think5whysCode}
                  disabled
                />
              </div>

              {/* <UserProfileUploadImage pictureData={{ pictureData }} /> */}

              <div className='flex flex-col'>
                <label>Gender:</label>
                <select
                  className="profile-select bg-gray-600 rounded-md px-2 py-1"
                  value={profileData.gender}
                  onChange={(e) => setProfileData({ ...profileData, gender: e.target.value })}
                >
                  <option value={0}>Male</option>
                  <option value={1}>Female</option>
                  <option value={2}>Other</option>
                </select>
                {errors.gender && <span className="text-red-500 text-xs">{errors.gender}</span>}
              </div>

              <div className='flex flex-col'>
                <label>Date of Birth:</label>
                <input
                  className="profile-date bg-gray-600 rounded-md px-2 py-1"
                  type="date"
                  value={profileData.dob ? profileData.dob.substring(0, 10) : ''}
                  onChange={(e) => setProfileData({ ...profileData, dob: e.target.value })}
                />
              </div>

              <div className='flex flex-col'>
                <label className='text-yellow-200'>Email:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="email"
                  value={profileData.email}
                  disabled
                />
              </div>

              <div className='flex flex-col'>
                <label className='text-yellow-200'>Mobile Number:</label>
                <input
                  className="profile-input bg-gray-600 rounded-md px-2 py-1"
                  type="tel"
                  value={profileData.mobile}
                  onChange={(e) => setProfileData({ ...profileData, mobile: e.target.value })}
                />
                {errors.mobile && <span className="text-red-500 text-xs">{errors.mobile}</span>}
              </div>

              <div className='flex flex-col'>
                <label>Additional Email:</label>
                <input
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    type="email"
                    value={profileData.addOnEmail}
                    onChange={(e) => setProfileData({ ...profileData, addOnEmail: e.target.value })}
                />
            </div>

            <div className='flex flex-col'>
                <label>Additional Contact:</label>
                <input
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    type="tel"
                    value={profileData.addOnContact}
                    onChange={(e) => setProfileData({ ...profileData, addOnContact: e.target.value })}
                />
            </div>

            <div className='flex flex-col'>
                <label className='text-yellow-200'>City:</label>
                <input 
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    style={{ border: '1px solid #ccc'}}
                    type="text"
                    value={profileData.city}
                    onChange={(e) => setProfileData({ ...profileData, city: e.target.value })}
                />
            </div>

            <div className='flex flex-col'>
                <label>State:</label>
                <input
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    type="text"
                    style={{ border: '1px solid #ccc' }}
                    value={profileData.state}
                    onChange={(e) => setProfileData({ ...profileData, state: e.target.value })}
                />
            </div>

            <div className='flex flex-col'>
                <label>Country:</label>
                <input
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    type="text"
                    style={{ border: '1px solid #ccc' }}
                    value={profileData.country}
                    onChange={(e) => setProfileData({ ...profileData, country: e.target.value })}
                />
            </div>

            <div className='flex flex-col'>
                <label>Postal Code:</label>
                <input
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    type="text"
                    style={{
                        border: '1px solid #ccc',
                        width: '100px',
                    }}
                    value={profileData.pincode}
                    onChange={(e) => setProfileData({ ...profileData, pincode: e.target.value })}
                />
            </div>

            <div className='flex flex-col'>
                <label>Address:</label>
                <textarea
                    className="bg-gray-600 rounded-md px-2 py-1"
                    style={{
                        border: '1px solid #ccc',
                        maxWidth: '650px',
                        maxHeight: '150px',
                    }}
                    value={profileData.address}
                    onChange={(e) => setProfileData({ ...profileData, address: e.target.value })}
                />
            </div>

            <div className='flex flex-col'>
                <label>UPI ID:</label>
                <input
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    type="text"
                    value={profileData.upiID}
                    onChange={(e) => setProfileData({ ...profileData, upiID: e.target.value })}
                />
            </div>

            <div className='flex flex-col'>
                <label className='text-yellow-200'>Institution:</label>
                <input
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    type="text"
                    value={profileData.institution}
                    onChange={(e) => setProfileData({ ...profileData, institution: e.target.value })}
                />
            </div>

            <div className='flex flex-col'>
                <label className='text-yellow-200'>Social Links:</label>
                <textarea
                    className="bg-gray-600 rounded-md px-2 py-1"
                    style={{
                        border: '1px solid #ccc',
                        maxWidth: '650px',
                        maxHeight: '100px',
                    }}
                    value={profileData.socialLinks}
                    onChange={(e) => setProfileData({ ...profileData, socialLinks: e.target.value })}
                />
            </div>

            <div className='flex flex-col'>
                <label className='text-yellow-200'>Personal Page Link:</label>
                <input
                    className="profile-input bg-gray-600 rounded-md px-2 py-1"
                    type="text"
                    value={profileData.personalPageLink}
                    onChange={(e) => setProfileData({ ...profileData, personalPageLink: e.target.value })}
                />
            </div>

            <div className='flex flex-col'>
                <label>Brief Bio (What I Do?):</label>
                <textarea
                    className="bg-gray-600 rounded-md px-2 py-1"
                    style={{
                        border: '1px solid #ccc',
                        maxWidth: '650px',
                        maxHeight: '150px',
                    }}
                    value={profileData.bio}
                    onChange={(e) => setProfileData({ ...profileData, bio: e.target.value })}
                />
            </div>

            <div className='flex items-center'>
                <input
                    className='mr-4'
                    type="checkbox"
                    checked={profileData.showPrayerOnLogin}
                    onChange={(e) => setProfileData({ ...profileData, showPrayerOnLogin: e.target.checked })}
                />
                <label>Show Prayer / Self Reminder On Login:</label>
            </div>

            <div className='flex flex-col'>
                <label>Prayer / Reminder / Vision:</label>
                <textarea
                    className="bg-gray-600 rounded-md px-2 py-1"
                    style={{
                        border: '1px solid #ccc',
                        maxWidth: '650px',
                        maxHeight: '200px',
                    }}
                    value={profileData.prayer}
                    onChange={(e) => setProfileData({ ...profileData, prayer: e.target.value })}
                />
            </div>

            <div className='flex flex-col'>
                <label>Remarks:</label>
                <textarea
                    className="bg-gray-600 rounded-md px-2 py-1"
                    style={{
                        border: '1px solid #ccc',
                        maxWidth: '650px',
                        maxHeight: '100px',
                    }}
                    value={profileData.remarks}
                    onChange={(e) => setProfileData({ ...profileData, remarks: e.target.value })}
                />
            </div>

            <p className='text-yellow-200 text-center mb-4'>
                Label/Information in yellow color will be displayed on your Digital Card
            </p>

            <div className='flex justify-center'>
                <button className='ml-4 text-sm' onClick={handleCancel} disabled={true}>
                    My Products & Services
                </button>
                <button className='ml-4 text-sm' onClick={handleCancel} disabled={true}>
                    My Customers
                </button>
                <button className='ml-4 text-sm' onClick={handleCancel} disabled={true}>
                    How We Do?
                </button>
            </div>
            </div>
            {updateSuccess && (
              <div className="success-message text-green-500 text-lg mt-4">
                {updateSuccessMsg}
              </div>
            )}
            <div className='flex mt-6'>
              <button
                className='update-profile-button px-4 py-2 bg-green-600 rounded-md text-white hover:bg-green-700 w-40'
                onClick={handleProfileUpdate}
              >
                Update
              </button>
              <button
                className='update-profile-button px-4 py-2 bg-red-600 rounded-md text-white hover:bg-red-700 w-40'
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </>
        )}

        {!profileExists && createSuccess && (
          <div className="flex flex-col justify-center success-message text-green-500 text-xl mt-4">
            {createSuccessMsg}
            <button
                className='update-profile-button px-4 py-2 bg-red-600 rounded-md text-white hover:bg-red-700 w-40'
                onClick={() => navigate("/my-profile-home")}
              >
                OK
            </button>
          </div>
        )}
     </div>
     <footer className="bg-black border-t border-blue-400 text-white py-4 mt-2">
        <div className="mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm lg:text-lg text-yellow-200">
            (c) 2025 Think5Whys Global DeepTech Solutions.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-[#005C5C]">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-[#005C5C]">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-[#005C5C]">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-[#005C5C]">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MyProfile;



